export function buildScope(projectId: string): string {
  return [
    'openid',
    'profile',
    'email',
    'offline_access',
    `urn:zitadel:iam:org:project:id:${projectId}:aud`,
    'urn:zitadel:iam:org:projects:roles',
    // Reserved Zitadel scope: emits urn:zitadel:iam:user:resourceowner:id/:name/:primary_domain.
    // The backend requires the resourceowner id as a required identity claim.
    'urn:zitadel:iam:user:resourceowner',
  ].join(' ');
}
